import React from 'react';
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';

const LightboxCloseButtonContainer = styled.div`
  position: fixed;
  right: 32px;
  padding: 16px;
  top: 16px;
  cursor: pointer;
  user-select: none;
  color: #FFF;

  @supports (-webkit-touch-callout: none) {
    top: 80px;
    right: 48px;
  }

  & svg {
    width: 30px;
    height: auto;
  }
`;

const LightboxCloseButton = (props) => (
  <LightboxCloseButtonContainer {...props}>
    <CloseIcon />
  </LightboxCloseButtonContainer>
);

export default LightboxCloseButton;
